module.exports = __webpack_public_path__ + "static/EventsAssets-2e7c3fb1d1dc643a073cc75e39c61b82.png";